import Api from "../Api/Api";
import {LOAD_ORDER_ERROR, LOAD_ORDER_LOADING, LOAD_ORDER_SUCCESS, SUCCESS_API_CALL, MANAGE_LOADING, LANGUAGE_HAS_CHANGED} from "../constants/action-types";

export function getStyles(domainID:number,storeID:number, preview:boolean) {
    return (dispatch:any)=>{
        Api.getStyles(domainID,storeID,preview).then(response=>response.json())
            .then(data=>dispatch({type:SUCCESS_API_CALL,data}))
    }
}

export function getOrder (orderNumber:string) {
    return (dispatch: any) => {
        if(orderNumber && (orderNumber !== '#####' && orderNumber.length === 5 || orderNumber !== '######' && orderNumber.length === 6)){
            dispatch({type: LOAD_ORDER_LOADING});
           return Api.getOrderStatus(orderNumber)
            .then(response => {
              if (!response.ok)
                throw new Error(`Error querying service for weblink ${orderNumber}`)
              return response
            })
            .then(response => response.json())
            .then(data => dispatch({type: LOAD_ORDER_SUCCESS, data}))
            .catch(() => dispatch({type: LOAD_ORDER_ERROR, error: true}))
        } else {
            dispatch({ type: LOAD_ORDER_ERROR, error: true })
            return Promise.resolve({error: `"${orderNumber}" is not valid order number`});
        }
    }
}
export function managePreloader (value: boolean) {
    return (dispatch: any) => dispatch({type: MANAGE_LOADING, value});

}

export function languageChanged(lng: string){
    return (dispatch: any) => dispatch({type:LANGUAGE_HAS_CHANGED, lng});
}
